import React from 'react';
import { Box, Paper, Slide, FormControl } from '@mui/material';
import Container from '@mui/material/Container';
import PropTypes from 'prop-types';

export default function ScreenContainer(props) {
  const containerRef = React.useRef(null);
  return (
    <Container maxWidth="md">
      {props.error}
      <Paper
        elevation={2}
        ref={containerRef}
        variant="screen"
        sx={{ maxHeight: '75vh', overflowY: 'auto', overflowX: 'hidden' }}
      >
        <Slide
          // eslint-disable-next-line react/prop-types
          direction={props.direction}
          // eslint-disable-next-line react/prop-types
          in={props.slideIn}
          container={containerRef.current}
        >
          <Box
            component={FormControl}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '30px',
              padding: '60px 50px',
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            {props.children}
          </Box>
        </Slide>
      </Paper>
    </Container>
  );
}
ScreenContainer.propTypes = {
  children: PropTypes.node,
  error: PropTypes.element,
};
